export const SessionStorageKeys = {
  blockedLimitModalShown: "blocked_limit_modal_shown",
  addPaymentMethodProcessed: "add_payment_method_processed",
};
